<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title v-if="tutor">{{ tutor.full_name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-tabs right background-color="blur">
          <v-tab :to="{name: 'Tutor info', params: $route.params}">Info</v-tab>
          <v-tab :to="{name: 'Tutor edit', params: $route.params}">Edit</v-tab>
          <v-tab :to="{name: 'Tutor working hours', params: $route.params}">Working hours</v-tab>
          <v-tab :to="{name: 'Tutor sessions', params: $route.params}">Sessions</v-tab>
          <v-tab :to="{name: 'Tutor payments', params: $route.params}">Payments</v-tab>
          <v-tab :to="{name: 'Tutor limits', params: $route.params}">Limits</v-tab>
          <v-tab :to="{name: 'Tutor events', params: $route.params}">Events</v-tab>
          <v-tab :to="{name: 'Tutor reviews', params: $route.params}">Reviews</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <router-view @loadTutor="loadData" :tutor="tutor"></router-view>
  </section>
</template>

<script>
export default {
  data: () => ({
    tutor: null
  }),
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.tutor = await this.axios.get(`api/tutors/${this.$route.params.tutor_id}`)
          .then(({data}) => data.data)
    }
  }
}
</script>
